const APP_CONFIG = {
  FRONTEND_VERSION: 52,
  CLIENT_PLATFORM: "web",
};

export default APP_CONFIG;
